import { graphql } from '@/gql';
import type { AnnouncementInput } from '@/models/announcement';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const createAnnouncement = async (data: AnnouncementInput) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateAnnouncement($data: AnnouncementInputType!) {
        createAnnouncement(data: $data) {
          id
          title
          content
          expiredAt
          repeatedDate
          timeZone
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createAnnouncement!;
};
